{
  "actionbar.actions": "Дії",
  "actionbar.actionsAvailable": "Доступні дії.",
  "actionbar.clearSelection": "Очистити вибір",
  "actionbar.selected": "Вибрано: {count}",
  "actionbar.selectedAll": "Усе вибрано",
  "breadcrumbs.more": "Більше елементів",
  "button.pending": "в очікуванні",
  "calendar.invalidSelection": "{selectedCount, plural, one {Вибрана дата недоступна} other {Вибрані дати недоступні}}.",
  "combobox.noResults": "Результатів немає",
  "contextualhelp.help": "Довідка",
  "contextualhelp.info": "Інформація",
  "datepicker.endTime": "Час завершення",
  "datepicker.startTime": "Час початку",
  "datepicker.time": "Час",
  "dialog.alert": "Сигнал тривоги",
  "dialog.dismiss": "Скасувати",
  "dropzone.replaceMessage": "Перетягніть файл для заміни",
  "inlinealert.informative": "Інформація",
  "inlinealert.negative": "Помилка",
  "inlinealert.notice": "Попередження",
  "inlinealert.positive": "Успішно",
  "label.(optional)": "(необов’язково)",
  "label.(required)": "(обов’язково)",
  "menu.moreActions": "Більше дій",
  "menu.unavailable": "Недоступно, розгорніть для докладнішої інформації",
  "notificationbadge.indicatorOnly": "Нова активність",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Вибрати…",
  "picker.selectedCount": "{count, plural, =0 {Жодних елементів не вибрано} one {# елемент вибрано} other {Елементів вибрано: #}}",
  "slider.maximum": "Максимум",
  "slider.minimum": "Мінімум",
  "table.cancel": "Скасувати",
  "table.drag": "Перетягнути",
  "table.editCell": "Редагувати клітинку",
  "table.loading": "Завантаження…",
  "table.loadingMore": "Завантаження інших об’єктів...",
  "table.resizeColumn": "Змінити розмір стовпця",
  "table.save": "Зберегти",
  "table.sortAscending": "Сортувати за зростанням",
  "table.sortDescending": "Сортувати за спаданням",
  "tag.actions": "Дії",
  "tag.hideButtonLabel": "Показувати менше",
  "tag.noTags": "Немає",
  "tag.showAllButtonLabel": "Показати всі ({tagCount, number})",
  "toast.clearAll": "Очистити все",
  "toast.collapse": "Згорнути",
  "toast.showAll": "Показати все"
}
